var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"events"},[_c('post-back',{attrs:{"title":_vm.tr.main_events}}),_c('div',{staticClass:"containers events-container"},[_c('posts-grid',{attrs:{"posts":_vm.events,"total":_vm.total}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }